import React, { useContext, useEffect } from 'react'
import deleteIcon from '../../images/png/deleteIcon.png'
import editIcon from '../../images/png/editIcon.png'

import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { CartsContext } from '../../context/cart'

const Image = styled.img`
    width: 28px;
    height:26px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`
const CheckBox = styled.input`

    appearance: none;
`
const ButtonStatus = styled.button`

    width: 106px;
    height: 28px;
    border: none;
    font-size: 11px;
    border-radius: 60px;

    @media screen and (max-width:820px){
        width: 100%;
        font-size: 9px;
        border-radius:50px;
        
    }


`

const TableListCarts = ({ data, structure }) => {

    const {getAll,carts,get,setShowModalRequest} = useContext(CartsContext)
    
    useEffect(() => {
        getAll()
    },[])

    return (
        <div className='container_startpn_table_categorys'>
            <table>

                <thead className='container_startpn_table_categorys'>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>


                <tbody className=''>
                    {String(carts).length == 0

                        ?
                        <tr>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                        </tr>
                        :

                        carts?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td onClick={() => {get(item.id);}}>#{item.id}</td>
                                    <td onClick={() => {get(item.id);}}>{item.user_name}</td>
                                    <td onClick={() => {get(item.id);}} data-toggle="modal" data-target=""><ButtonStatus style={{ background: "#FFF7AA", color: "#C6B200" }}>{item.status == "pending" ? "Pendente" : ""}</ButtonStatus></td>


                                </tr>
                            )
                        })}



                </tbody>
            </table>
        </div>
    )
}

export default TableListCarts